import { useMutation } from 'convex/react';
import { api } from 'convex/_generated/api';
import { Id } from 'convex/_generated/dataModel';

export function useDuplicateGarden() {
  return useMutation(api.gardens.mutations.duplicateGarden).withOptimisticUpdate(
    (localStore, { gardenId }) => {
      const current = localStore.getQuery(api.gardens.queries.getUserGardens, {});
      if (current === undefined) return;

      const source = current.find((g) => g._id === gardenId);
      if (!source) return;

      localStore.setQuery(api.gardens.queries.getUserGardens, {}, [
        ...current,
        {
          ...source,
          _id: `__opt_${Date.now()}` as unknown as Id<'gardens'>,
          _creationTime: Date.now(),
          name: `${source.name} (Copy)`,
        },
      ]);
    }
  );
}
